"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _HeaderCell = _interopRequireDefault(require("../cell/HeaderCell"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const TableHeader = _ref => {
  let {
    headerContent,
    sortConfig,
    handleClick,
    lookupTextFunction,
    orderBy,
    hasExpandableRows
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "table-row"
  }, headerContent.map(headerContent => {
    const key = headerContent.columnKey;
    return /*#__PURE__*/_react.default.createElement(_HeaderCell.default, {
      key: key,
      columnKey: key,
      headerValue: headerContent.columnName,
      onClick: sortConfig !== null && sortConfig !== void 0 && sortConfig.sortableColumns.find(columnConfig => columnConfig.columnKey === key) ? handleClick : undefined,
      sorting: orderBy[key] != null ? {
        sortDirection: orderBy[key],
        altText: lookupTextFunction ? lookupTextFunction("alt.sort.".concat(orderBy[key])) : "sort-".concat(orderBy[key])
      } : undefined,
      tooltip: headerContent.tooltip
    });
  }), hasExpandableRows && /*#__PURE__*/_react.default.createElement("div", {
    className: "item-cell expand-grid"
  })));
};
var _default = exports.default = TableHeader;